export default {
  login: '/api/login',
  sysUserVerifyPhone: '/api/system/sysUser/verify/phone', // 验证手机号是否存在
  getPhoneCode: '/api/eros/se/seMerchant/sms/verCode', // 手机注册验证码
  getResetPassword: '/api/system/sysUser/reset/password/send', // 重设密码验证码
  checkVerCode: '/api/system/sysUser/check/verCode', // 验证码校验
  sendEmail: ' /api/system/sysUser/send/mail', // 发送邮件
  emailResetPassword: '/api/system/sysUser/email/reset/password', // 邮箱修改密码
  phoneResetPassword: '/api/system/sysUser/phone/reset/password', // 手机号密码修改
  loginValidateCode: '/api/login/verifyCode',
  sign: '/api/system/sysCloudImg/cos/sign', // 对象存储签名
  getStatus: '/api/system/sysStatus/status/list',
  getAreaList: '/api/system/sysArea/parentId/list',
  businessAnalysis: '/api/eros/so/soBillOrder/intelligent/business/analysis', // 智能分析
  checkPrivilege: '/api/system/sysRolePrivilege/check/privilege', // 首页检测是否有跳转权限
  baseInfo: {
    field: '/api/baseInfo/field',
    node: '/api/baseInfo/node',
    nodeApp: '/api/baseInfo/nodeApp',
    host: '/api/baseInfo/host',
    app: '/api/baseInfo/app',
    white: '/api/baseInfo/white',
    queue: '/api/baseInfo/queue',
    exchange: '/api/baseInfo/exchange',
    strategy: '/api/baseInfo/strategy',
    insertSpecsList: '/api/eros/as/asGoodsSpecsMap/batch/insert',
    getSpecsList: '/api/eros/as/asGoodsSpecsMap/goodsId/list',
    collectActive: '/api/eros/se/seDevice/collect/info', // 设备激活
    collectAddress: '/api/eros/seStore/address'// 设备信息 获取地址
  },
  statistics: {
    node: '/api/statistics/node',
    app: '/api/statistics/app'
  },
  log: {
    queue: '/api/log/queue',
    warning: '/api/log/warning',
    file: '/api/log/file'
  },
  monitor: {
    host: '/api/monitor/host',
    hostCPU: '/api/monitor/hostCPU',
    hostMemory: '/api/monitor/hostMemory',
    hostDisk: '/api/monitor/hostDisk',
    hostCPUList: '/api/monitor/hostCPUList',
    hostMemoryList: '/api/monitor/hostMemoryList',
    hostDiskList: '/api/monitor/hostDiskList'
  },
  system: {
    otherUser: '/api/system/sysUser/other',
    account: '/api/system/sysUser',
    type: '/api/system/sysUser/type',
    rolePrivilege: '/api/system/sysRole/privilege',
    role: '/api/system/sysRole',
    roleOther: '/api/system/sysRole/other',
    notice: '/api/system/sysMessage',
    upgradePwd: '/api/system/sysUser/password',
    seStore: '/api/eros/seStore',
    buy: '/api/system/user/buy',
    sysJurisdiction: '/api/system/sysJurisdiction/list',
    businessClear: '/api/system/sysJurisdiction/business/clear',
    getMerchant: '/api/eros/se/seMerchant/userId',
    submitMerchant: '/api/eros/se/seMerchant',
    getCategory: '/api/system/sysIndustryCategory/parentId',
    payMode: '/api/system/sysPayMode',
    imgCode: '/api/system/sysCloudImg',
    guide: '/api/system/sysGuideMap',
    log: '/api/system/sysLog',
    handoverRecord: '/api/system/sysHandoverRecord',
    handoverRecordExport: '/api/system/sysHandoverRecord/export',
    selectedAppletTem: '/api/system/sysAppConfig/template',
    draftAddTemplate: '/api/system/sysAppConfig/add/template', // 草稿箱中的模板添加
    templateOmit: '/api/system/sysAppConfig/delete/template', // 模板中的删除模板
    queryAuditCount: '/api/system/sysAppConfig/audit/count', // 提审与加急次数查询
    submitAppletAudit: '/api/system/sysAppConfig/audit', // 小程序提交审核
    appletRelease: '/api/system/sysAppConfig/release', // 小程序发布
    undoAudit: '/api/system/sysAppConfig/undoCode/audit', // 小程序撤销审核操作
    urgentAppletList: '/api/system/sysAppProgramExamine/list', // 加急小程序列表拉取
    merChantInfo: '/api/system/sysAppProgramExamine/query', // 加急小程序查询具体商户信息
    isAuthSuccess: '/api/system/sysAppConfig/auth/success', // 小程序授权是否成功
    isAuthSuccess_2: '/api/system/sysWechatConfig/auth/success', // 公众号授权是否成功
    preauthcode: '/api/system/sysWechatConfig/create/preauthcode', // 决定是否跳转微信公众号授权页
    publicNumAuthQuery: '/api/system/sysWechatConfig/query', // 公众号授权信息
    publicNumConfigReset: '/api/system/sysWechatConfig/reset', // 公众号配置重置
    publicNumConfigUpdate: '/api/system/sysWechatConfig', // 公众号配置提交
    publicNumMenuQuery: '/api/system/sysWechatConfig/query/menu', // 公众号自定义菜单查询
    lastTemplateListGet: '/api/system/sysMerchantTemplatePush/list', // 最新版公众号模板获取
    lastTemplateListPush: '/api/system/sysMerchantTemplatePush', // 最新版公众号模板保存及更新
    newTemplateList: '/api/system/sysMerchantTemplatePush/template', // 新版公众号模板数据获取
    newTemplateUpdate: '/api/system/sysMerchantTemplatePush/template/update', // 新版公众号模板数据保存及更新及开启使用
    oldSysMarkList: '/api/system/sysMark/list', // 旧版公众号模板数据查询
    oldSysMark: '/api/system/sysMark', // 旧版公众号模板数据
    otherPay: '/api/system/sysPayMode', // 其他支付具体支付方式
    logout: '/api/system/sysUser/logout', // 店长、收银员、用户退出,
    sysRole: '/api/system/sysRole/now/list', // 新角色列表
    sysUser: '/api/system/sysUser', // 新用户
    sysUserAdd: '/api/system/sysUser/add', // 新用户新增
    sysUserGet: '/api/system/sysUser/get', // 新用户 查询详情
    staffPage: '/api/system/sysUser/staff', // 新用户 分页
    sysPayMode: '/api/system/sysPayMode/pay/list', // 自定义支付
    sysPayConfigGet: '/api/system/sysPayConfig/get', // 获取渠道号信息详情
    sysPayConfig: '/api/system/sysPayConfig',// 商户号保存
    exportError: '/api/system/sysImportErrorGoods/export/error', //错误信息导出
    updateDbyMchntsndSms: '/api/system/sysPayConfig/send/verify/code',//修改渠道号发送短信
    updateDbyMchnt: '/api/system/sysPayConfig/update/dby/mchnt',//短信验证修改渠道号
  },
  store: {
    getStoreDetail: '/api/eros/seStore/detail',
    store: '/api/eros/seStore',
    storeInfo: '/api/eros/seStore/info', // 根据参数获取门店或商户信息
    storeList: '/api/eros/seStore/merchant/store', // 门店（带有商户）
    device: '/api/eros/se/seDevice',
    deviceCategory: '/api/eros/se/seDeviceCategory',
    saleData: '/api/eros/so/soBillOrder/home/sell/summary/statistics',
    salesRanking: '/api/eros/so/soBillOrder/goods/sell/ranking',
    paymentSummary: '/api/eros/so/soBillOrder/pay/summary/statistics',
    goodSellData: '/api/eros/so/soBillOrder/category/sell/statistics',
    actualLineData: '/api/eros/so/soBillOrder/sell/actual/state',
    dynamicData: '/api/eros/so/soBillOrder/sell/actual/data',
    summaryExport: '/api/eros/so/soBillOrder/store/day/salesSummary/export',
    summaryGoodsExport: '/api/eros/so/soBillOrder/goods/salesSummary/export',
    summaryCategoryExport: '/api/eros/so/soBillOrder/category/salesSummary/export',
    summarySupplierExport: '/api/eros/so/soBillOrder/supplier/salesSummary/export',
    summaryBrandExport: '/api/eros/so/soBillOrder/brand/salesSummary/export',
    summarySummaryExport: '/api/eros/so/soBillOrder/order/export',
    mainStore: '/api/eros/seStore/set/main/store',
    closeStore: '/api/eros/seStore/set/close/store',
    syncData: '/api/eros/seStore/sync/dada',
    seNotice: '/api/eros/se/seNotice', // 系统消息
    downloadQrCode: '/api/eros/seStore/query/qrCode', // 下载进件码
  },
  delivery: {
    requisition: '/api/eros/dn/dnRequireOrder',
    requisitionGoods: '/api/eros/dn/dnRequireGoodsMap',
    requisitionDetails: '/api/eros/dn/dnRequireOrder/querydetails',
    requisitionDetailExport: '/api/eros/dn/dnRequireOrder/detail/export',
    requisitionQuote: '/api/eros/dn/dnRequireOrder/quote',
    transferring: '/api/eros/dn/dnAllocationOrder',
    transferringGoods: '/api/eros/dn/dnAllocationGoodsMap',
    transferringDetails: '/api/eros/dn/dnAllocationOrder/querydetails',
    transferringDetailsExport: '/api/eros/dn/dnAllocationOrder/detail/export',
    deliver: '/api/eros/dn/dnDistributionOrder',
    deliverGoods: '/api/eros/dn/dnDistributionGoodsMap',
    deliverDetails: '/api/eros/dn/dnDistributionOrder/querydetails',
    deliverDetailsExport: '/api/eros/dn/dnDistributionOrder/detail/export',
    distributionSummarize: '/api/eros/dn/dnDistributionOrder/distribution/summarize',
    distributionSummarizeExport: '/api/eros/dn/dnDistributionOrder/distribution/summarize/export',
    goodsSummarize: '/api/eros/dn/dnDistributionOrder/goods/summarize',
    goodsSummarizeExport: '/api/eros/dn/dnDistributionOrder/goods/summarize/export',
    detailedSummarize: '/api/eros/dn/dnDistributionOrder/detailed/summarize',
    detailedSummarizeExport: '/api/eros/dn/dnDistributionOrder/detailed/summarize/export',
    requisitionGoodsExport: '/api/eros/dn/dnRequireOrder/require/goods/export',
    transferringGoodsExport: '/api/eros/dn/dnAllocationOrder/allocation/goods/export',
    deliverGoodsExport: '/api/eros/dn/dnDistributionOrder/distribution/goods/export',
    ddDeDaMerchant: '/api/eros/de/deDaMerchant', // 达达商户
    accountQuery: '/api/eros/de/deDaMerchant/balance/query', // 余额查询
    recharge: '/api/eros/de/deDaMerchant/recharge', // 充值
    uuDaMerchant: '/api/eros/de/deUuMerchant', // uu商户
    uuAccountQuery: '/api/eros/de/deUuMerchant/balance', // uu余额查询
    uuRecharge: '/api/eros/de/deUuMerchant/recharge', // uu 充值
    uuCode: '/api/eros/de/deUuMerchant/code', // uu 获取验证码
    dadaRegist: '/api/eros/de/deDaMerchant/register', // 达达 注册
    importGoods: '/api/eros/dn/dnRequireGoodsMap/require/import/goods', // 要货/调拨批量导入商品
    requireDownloadTemplate: '/api/eros/dn/dnRequireGoodsMap/require/download/template', // 调拨模板下载
    allocationDownloadTemplate: '/api/eros/dn/dnRequireGoodsMap/require/allocation/download/template', // 调拨模板下载
    orderNullify: '/api/eros/dn/dnRequireOrder/order/nullify',
    differenceOrder: '/api/eros/dn/dnAllocationDifferenceOrder',
    differenceOrderDetailExport: '/api/eros/dn/dnAllocationDifferenceOrder/detail/export',
    differenceGoods: '/api/eros/dn/dnAllocationDifferenceOrderMap',
    requireGoodsSummery: '/api/eros/dn/dnAllocationGoodsMap/require/goods/summary',//调拨汇总
    requireGoodsDetail: '/api/eros/dn/dnAllocationGoodsMap/require/goods/detail/list',//调拨详情
    batchUpdateNumber: '/api/eros/dn/dnAllocationGoodsMap/batch/update/number',//批量更新调拨数量
  },
  archives: {
    categoryName: '/api/eros/as/asGoodsCategory/check/category/name', // 商品类别名称校验
    brandName: '/api/eros/as/asGoodsBrand/check/brand/name', // 商品品牌名称校验
    supplierName: '/api/eros/as/asSupplier/check/supplier/name', // 供应商名称校验
    storeName: '/api/eros/seStore/check/store/name', // 门店名称校验
    customerName: '/api/eros/wl/wlWholesaleCustomer/check/customer/name', // 客户名称校验
    businessTips: '/api/eros/as/asGoods/prompt/list',
    hometips: '/api/eros/we/weWarehouseGoodsMap/home/tips/list', // 系统提示
    businessAgent: '/api/system/sysTask/type/list',
    brand: '/api/eros/as/asGoodsBrand', // 商品品牌
    supplier: '/api/eros/as/asSupplier',
    getGoodsSet: '/api/eros/as/asGoodsDefault',
    goodsInfo: '/api/eros/as/asGoods',
    goodsBranchPrice: '/api/eros/as/asGoods/branch/price/list',
    goodsInfoIncludeSpecs: '/api/eros/as/asGoods/specs',
    asGoodsSpecsMap: '/api/eros/as/asGoodsSpecsMap/specs', // 新调价单选择商品
    priceDadjap: '/api/eros/as/asPriceAdjustmentOrder',
    priceDadjapGoods: '/api/eros/as/asAdjustmentGoodsMap',
    goodsUnit: '/api/eros/as/asGoodsUnit',
    goodsCategory: '/api/eros/as/asGoodsCategory/parent',
    categoryList: '/api/eros/as/asGoodsCategory', // 商品类别
    verifyBarcode: '/api/eros/as/asGoods/verify/barCode', // GET请求 brCode=条码 验证条码是否存在
    verifyAtrNo: '/api/eros/as/asGoods/verify/atrNo', // GET请求 atrNo=自编码验证自编码是否存在
    verifyPluCode: '/api/eros/as/asGoods/verify/pluCode', // GET请求 pluCode=自编码验证自编码是否存在
    getBarcode: '/api/eros/as/asGoods/get/barCode', // GET请求 获取条码
    getAtrNo: '/api/eros/as/asGoods/get/atrNo', // GET请求 获取自编码
    getPluCode: '/api/eros/as/asGoods/get/pluCode', // GET请求 Plu码
    goodsSpecs: '/api/eros/as/asGoodsSpecs',
    getCategoryCode: '/api/eros/as/asGoodsCategory/generate/code',
    getCheckCode: '/api/eros/as/asGoodsCategory/check/code',
    getCategoryTree: '/api/eros/as/asGoodsCategory/tree',
    goodsBarCode: '/api/eros/as/asGoodsBarcode',
    downLoadTemplate: '/api/eros/as/asGoods/download/barCodes/template',
    barCodeImport: '/api/eros/as/asGoods/import/barCodes',
    verifyBarCode: '/api/eros/as/asGoodsBarcode/verify/code',
    // goodsInsertBarCode: '/api/eros/as/asGoodsBarcode',
    syncCombine: '/api/eros/as/asGoods/sync/packaging',
    shopColumn: '/api/eros/seStore/list',
    getBarCodePage: '/api/eros/as/asGoodsBarcode',
    goodsExport: '/api/eros/as/asGoods/export',
    getErrorReason: '/api/eros/as/asGoodsOperationRecord/page', // 查询异常原因
    syncPacking: '/api/eros/as/asGoods/sync/packaging', // 同步商品大小包装关系
    syncGoodsToShop: '/api/eros/as/asGoods/sync/store/insert', // 商品同步插入门店
    syncColumnList: '/api/eros/as/asGoods/columns', // 获取同步列名集合
    updateSyncList: '/api/eros/as/asGoods/sync/store/update',
    syncTrans: '/api/eros/as/asGoods/sync/transfer',
    downLoadPackaging: '/api/eros/as/asGoods/download/packaging/template', // 下载商品大小包装
    downLoadTransModel: '/api/eros/as/asGoods/download/transfer/template', // 商品自动转货模板下载
    importPackaging: '/api/eros/as/asGoods/import/packaging', // 大小包装导入
    importTransfer: '/api/eros/as/asGoods/import/transfer', // 自动转货导入
    goodsImport: '/api/eros/as/asGoods/import',
    batchUpDate: '/api/eros/as/asGoods/batch/update',
    noGoodsSync: '/api/eros/as/asGoods/no/syn/goods',
    batchDelete: '/api/eros/as/asGoods/batch/delete',
    goodsReduction: '/api/eros/as/asGoods/batch/goods/reduction',
    downloadTemplate: '/api/eros/as/asGoods/download/template',
    queryGoods: '/api/eros/as/asGoods/query/goods',
    priceDownloadTemplate: '/api/eros/as/asPriceAdjustmentOrder/price/download/template',
    priceImport: '/api/eros/as/asPriceAdjustmentOrder/price/import',
    asRetailDefault: '/api/eros/as/asRetailDefault', // 零售业务设置
    getRetailDefault: '/api/eros/as/asRetailDefault/detail', // 获取零售业务设置 详情
    combinationPage: '/api/eros/as/asGoodsCombination/retale',
    combination: '/api/eros/as/asGoodsCombination',
    combinationSonList: '/api/eros/as/asGoodsCombination/son/list',
    goodsStore: '/api/eros/as/asGoods/store',
    asGoodsDefault: '/api/eros/as/asGoodsDefault', // 商品档案业务设置 提交
    asGoodsDefaultDetail: '/api/eros/as/asGoodsDefault/detail', // 商品档案业务设置 获取设置详情
    goodsNameRepeat: '/api/eros/as/asGoods/check/goods/name', // 商品名称重复校验
    asGoodsDefaultInfo: '/api/eros/as/asGoodsDefault/info', // 商品档案业务设置信息
    batchUpdate: '/api/eros/as/asGoods/batch/update/goods/info',// 档案批量修改
    mnemonicCodeCreate: '/api/eros/as/asGoods/create/mnemonic/code',// 助记码重新生成
    abbreviateCreate: '/api/eros/as/asGoods/create/abbreviate',// 简称重新生成
    queryGoodsCountList: '/api/eros/as/asGoods/count/list',// 简称重新生成
    recipe: '/api/eros/as/asRecipe',// 商品做法
    goodsRecipe: '/api/eros/as/asGoodsRecipeMap',// 商品做法关联
    specsMap: '/api/eros/as/asGoodsSpecsMap',
    exportGoodsMapDetail: '/api/eros/as/asPriceAdjustmentOrder/export/details',
  },
  wholesale: {
    archives: '/api/eros/wl/wlWholesaleCustomer',
    wholesaleSales: '/api/eros/wl/wlWholesaleOrder',
    wholesaleReturn: '/api/eros/wl/wlWholesaleReturnOrder',
    wholesaleQuery: '/api/eros/wl/wlWholesaleOrderGoodsMap',
    wholesaleGoods: '/api/eros/wl/wlWholesaleOrderGoodsMap/wholesale/goods/summarize',
    wholesaleBills: '/api/eros/wl/wlWholesaleOrderGoodsMap/wholesale/customer/summarize',
    wholesaleStore: '/api/eros/wl/wlWholesaleOrderGoodsMap/wholesale/store/summarize',
    salesCompleteBills: '/api/eros/wl/wlWholesaleReturnOrder/wholesale/sell/complete', // 获取批发销售已完成订单
    salesGoods: '/api/eros/wl/wlWholesaleReturnOrder/wholesale/sell',
    archivesExport: '/api/eros/wl/wlWholesaleCustomer/wholesale/customer/export',
    salesExport: '/api/eros/wl/wlWholesaleOrder/wholesale/sales/export',
    orderDetail: '/api/eros/wl/wlWholesaleOrder/detail/export', // 批发销售单详情导出
    returnOrderDetail: '/api/eros/wl/wlWholesaleReturnOrder/detail/export', // 批发退货单详情导出
    returnExport: '/api/eros/wl/wlWholesaleReturnOrder/wholesale/return/export',
    wholesaleGoodsExport: '/api/eros/wl/wlWholesaleOrderGoodsMap/wholesale/goods/export',
    wholesaleBillsExport: '/api/eros/wl/wlWholesaleOrderGoodsMap/wholesale/order/export',
    wholesaleStoreExport: '/api/eros/wl/wlWholesaleOrderGoodsMap/wholesale/warehouse/export',
    wholesaleImportGoods: '/api/eros/wl/wlWholesaleOrderGoodsMap/wholesale/import/goods', // 批发销售/退货导入商品
    wholesaleTemplateExport: '/api/eros/wl/wlWholesaleOrderGoodsMap/wholesale/template/export', // 批发销售/退货模板下载
    goodsProfit: '/api/eros/wl/wlWholesaleOrderGoodsMap/wholesale/goods/profit',//商品明细毛利
    orderProfit: '/api/eros/wl/wlWholesaleOrderGoodsMap/wholesale/order/profit',//单据毛利
    goodsProfitExport: '/api/eros/wl/wlWholesaleOrderGoodsMap/wholesale/goods/profit/export',//商品明细毛利导出
    orderProfitExport: '/api/eros/wl/wlWholesaleOrderGoodsMap/wholesale/order/profit/export',//单据毛利导出
    wholesaleOrders: '/api/eros/wl/wlWholesaleReturnOrder/wholesale/sell/complete/page',//批发销售单
  },
  member: {
    setting: '/api/eros/mb/mbMemberDefault',
    category: '/api/eros/mb/mbMemberCategory',
    archives: '/api/eros/mb/mbMember',
    mbIntegralGift: '/api/eros/mb/mbIntegralGift',
    mbIntegralGiftDetail: '/api/eros/mb/mbIntegralGift/detail', // 积分兑换明细
    mbIntegralGiftRecord: '/api/eros/mb/mbIntegralGiftRecord',
    integralSetting: '/api/eros/mb/mbMemberIntegral',
    plusSetting: '/api/eros/mb/mbPlusProduct',
    depositRecord: '/api/eros/mb/mbDepositRecord',
    archivesExport: '/api/eros/mb/mbMember/member/export',
    meberRecord: '/api/eros/so/soBillOrder/member/record', // 会员消费记录
    meberRecordExport: '/api/eros/so/soBillOrder/member/record/export', // 会员消费记录导出
    consumeRecord: '/api/eros/so/soBillOrder/member/storage/consume/record', // 会员储值消费明细
    consumeRecordExport: '/api/eros/so/soBillOrder/member/storage/consume/record/export', // 会员储值消费明细导出
    businessOverview: '/api/eros/so/soBillOrder/business/overview', // 营业概况
    businessOverviewExport: '/api/eros/so/soBillOrder/business/overview/export', // 营业概况导出
    rechargeScheme: '/api/eros/mb/mbRechargeScheme', // 充值方案
    integralRecord: '/api/eros/mb/mbMemberIntegralRecord', // 积分流水
    integralRecordExport: '/api/eros/mb/mbMemberIntegralRecord/export', // 积分流水导出
    mbMemberDefault: '/api/eros/mb/mbMemberDefault', // 会员业务设置 提交
    mbMemberDefaultDetail: '/api/eros/mb/mbMemberDefault/info', // 会员业务设置 详情
    downloadMemberTemplate: '/api/eros/mb/mbMember/member/template/download', // 下载模板
    importMember: '/api/eros/mb/mbMember/member/import', // 会员导入
    checkMemberName: '/api/eros/mb/mbMemberCategory/check/category/name', // 会员类别名称验重
    birthday: '/api/eros/mb/mbMember/birthday/tips', // 会员生日
    birthdayExport: '/api/eros/mb/mbMember/birthday/tips/export', // 会员生日
    mbRechargeRule: '/api/eros/mb/mbRechargeScheme/rule', // 会员充值金额验证
    mbMemberQuery: '/api/eros/mb/mbMember/query', // 根据号码 会员查询
    recharge: '/api/eros/mb/mbMember/recharge', // 会员充值
    reverseRecharge: '/api/eros/mb/mbMember/reverse/recharge', // 会员反充值
    fluctuate: '/api/eros/mb/mbMember/fluctuate', // 积分增减
    mbMemberState: '/api/eros/mb/mbMember/state',// 会员卡状态修改
    rechargeRecord: '/api/eros/mb/mbDepositRecord/recharge/record'// 会员充值记录
  },
  purchase: {
    goods: '/api/eros/pc/pcGoodsMap',
    exportGoodsMapDetail: '/api/eros/pc/pcPurchaseOrder/export/details',
    exportPurchaseStorageDetail: '/api/eros/pc/pcPurchaseStorageOrder/export/details',
    exportPurchaseReturnDetail: '/api/eros/pc/pcPurchaseReturnOrder/export/details',
    order: '/api/eros/pc/pcPurchaseOrder',
    stock: '/api/eros/pc/pcPurchaseStorageOrder',
    return: '/api/eros/pc/pcPurchaseReturnOrder',
    detailSum: '/api/eros/pc/pcGoodsMap/purchase/detail', // 采购明细汇总
    billsSum: '/api/eros/pc/pcPurchaseStorageOrder/bills/summarize', // 采购单据汇总
    supplierSum: '/api/eros/pc/pcGoodsMap/purchase/supplier/summery', // 供应商采购汇总
    orderExport: '/api/eros/pc/pcPurchaseOrder/order/goods/export',
    stockExport: '/api/eros/pc/pcPurchaseStorageOrder/stock/goods/export',
    returnExport: '/api/eros/pc/pcPurchaseReturnOrder/return/goods/export',
    detailSumExport: '/api/eros/pc/pcGoodsMap/purchase/detail/export',
    billsSumExport: '/api/eros/pc/pcPurchaseStorageOrder/summary/export',
    supplierSumExport: '/api/eros/pc/pcGoodsMap/purchase/supplier/export',
    purchaseImport: '/api/eros/pc/pcPurchaseOrder/purchase/import',
    templateDown: '/api/eros/pc/pcPurchaseOrder/purchase/template/export', // 模板下载
    pcPurchaseDefault: '/api/eros/pc/pcPurchaseDefault', // 采购业务设置 提交
    pcPurchaseDefaultDetail: '/api/eros/pc/pcPurchaseDefault/detail', // 采购业务设置 详情
    pcPurchaseDefaultInfo: '/api/eros/pc/pcPurchaseDefault/info', // 采购业务设置 信息
    purchaseStoreList: '/api/eros/pc/pcPurchaseDefault/purchase/store',
    purchaseReceipt: '/api/eros/pc/pcPurchaseReturnOrder/receive/audit/complete/page',//采购入库单
    procurement: '/api/eros/pc/pcPurchaseOrder/unfinished/order/page',//采购
  },
  warehouse: {
    warehouse: '/api/eros/we/weWarehouse',
    warehouseOrder: '/api/eros/we/weWarehouseOrder',
    querySummary: '/api/eros/we/weWarehouseOrderMap/summary',
    batch: '/api/eros/we/weBatchNumberOrder',
    batchExport: '/api/eros/we/weBatchNumberOrder/export',
    blitem: '/api/eros/we/weBlitemOrder',
    blitemOrderDetail: '/api/eros/we/weBlitemOrder/export',
    adjustInventory: '/api/eros/we/weAdjustInventoryOrder',
    adjustInventoryExport: '/api/eros/we/weAdjustInventoryOrder/export',
    inventorySum: '/api/eros/we/weWarehouseGoodsMap/inventory/sum',
    difference: '/api/eros/we/weBlitemDifferenceGoodsMap',
    differenceExport: '/api/eros/we/weBlitemDifferenceGoodsMap/blitem/export',
    differencePage: '/api/eros/we/weBlitemDifferenceGoodsMap/difference',
    blitemDetail: '/api/eros/we/weBlitemGoodsMap/detail',
    weBlitemGoodsMap: '/api/eros/we/weBlitemGoodsMap',
    blitemDetailExport: '/api/eros/we/weBlitemGoodsMap/check/detail/export',
    differenceDetail: '/api/eros/we/weBlitemDifferenceGoodsMap/detail',
    differenceDetailExport: '/api/eros/we/weBlitemDifferenceGoodsMap/check/difference/export',
    beLostDetail: '/api/eros/we/weBlitemGoodsMap/beLost/detail',
    beLostDetailExport: '/api/eros/we/weBlitemGoodsMap/check/beLost/export',
    warehouseGoods: '/api/eros/we/weWarehouseGoodsMap/goods',
    goodsGoodsExport: '/api/eros/we/weBlitemOrder/blitem/goods/export',
    businessGoodsExport: '/api/eros/we/weAdjustInventoryOrder/adjust/inventory/goods/export',
    detailGoodsExport: '/api/eros/we/weWarehouseOrder/warehouse/detail/export',
    querySummaryGoodsExport: '/api/eros/we/weWarehouseOrderMap/warehouse/summary/export',
    queryinventoryGoodsExport: '/api/eros/we/weWarehouseGoodsMap/inventory/sum/export',
    queryGoodsByBarCode: '/api/eros/we/weWarehouseGoodsMap/goods',
    queryGoodsAndInsert: '/api/eros/we/weWarehouseGoodsMap/goods/insert',
    warehouseImportGoods: '/api/eros/we/weWarehouseGoodsMap/warehouse/import/goods', // 存货盘点/存货调整批量导入商品
    blitemGoodsImport: '/api/eros/we/weWarehouseGoodsMap/blitemGoods/import', // 存货盘点导入商品
    downloadTemplate: '/api/eros/we/weWarehouseGoodsMap/download/template',
    adjustmentOrder: '/api/eros/we/wePurchaseAdjustmentOrder', // 成本调价单
    adjustmentOrderDetailExport: '/api/eros/we/wePurchaseAdjustmentOrder/detail/export', // 成本调价单
    adjustmentOrderAudit: '/api/eros/we/wePurchaseAdjustmentOrder', // 成本调价单审核
    purchaseAdjustmentQuery: '/api/eros/we/wePurchaseAdjustmentGoodsMap',
    adjustGoodsMap: '/api/eros/we/weAdjustGoodsMap',

  },
  retail: {
    billDetail: '/api/eros/so/soBillOrder/order/detail', // 小票预览
    retailSearch: '/api/eros/so/soBillOrder',
    cashierReport: '/api/eros/so/soBillOrder/cashier/report',
    goodsReport: '/api/eros/so/soBillOrder/goods/report',
    cashierDayStatement: '/api/eros/so/soBillOrder/cashier/day/statement',
    cashierReconciliation: '/api/eros/so/soBillOrder/cashier/reconciliation',
    pombinationPayDetail: '/api/eros/so/soBillOrder/pombination/pay/detail',
    refundDetail: '/api/eros/so/soBillOrder/cashier/day/refund/detail/list',
    customPay: '/api/eros/so/soBillOrder/cashier/customPay',
    cashierDateStatement: '/api/eros/so/soBillOrder/cashier/date/statement',
    storeCashier: '/api/eros/so/soBillOrder/cashier/store',
    goodsGrossMargin: '/api/eros/so/soBillOrderGoodsMap/goods/grossMargin',
    categoryGrossMargin: '/api/eros/so/soBillOrderGoodsMap/category/grossMargin',
    brandGrossMargin: '/api/eros/so/soBillOrderGoodsMap/brand/grossMargin',
    dayGrossMargin: '/api/eros/so/soBillOrderGoodsMap/day/grossMargin',
    storeGrossMargin: '/api/eros/so/soBillOrderGoodsMap/store/grossMargin',
    situation: '/api/eros/so/soBillOrder/situation',
    timeAnalysis: '/api/eros/so/soBillOrder/customer/hour/analysis',
    goodsSalesSummary: '/api/eros/so/soBillOrder/goods/salesSummary',
    categorySalesSummary: '/api/eros/so/soBillOrder/category/salesSummary',
    brandSalesSummary: '/api/eros/so/soBillOrder/brand/salesSummary',
    supplierSalesSummary: '/api/eros/so/soBillOrder/supplier/salesSummary',
    daySalesSummary: '/api/eros/so/soBillOrder/day/salesSummary',
    monthSalesSummary: '/api/eros/so/soBillOrder/month/salesSummary',
    storeSalesSummary: '/api/eros/so/soBillOrder/store/salesSummary',
    storeDaySalesSummary: '/api/eros/so/soBillOrder/store/day/salesSummary',
    cashierReportExport: '/api/eros/so/soBillOrder/cashier/report/export',
    goodsReportExport: '/api/eros/so/soBillOrder/goods/report/export',
    payReportExport: '/api/eros/so/soBillOrderPay/pay/report/export',
    cashierDayStatementExport: '/api/eros/so/soBillOrder/cashier/day/statement/export',
    cashierReconciliationExport: '/api/eros/so/soBillOrder/cashier/reconciliation/export',
    customPayExport: '/api/eros/so/soBillOrder/cashier/customPay/export',
    cashierDateStatementExport: '/api/eros/so/soBillOrder/cashier/date/export',
    storeCashierExport: '/api/eros/so/soBillOrder/cashier/store/export',
    goodsGrossMarginExport: '/api/eros/so/soBillOrderGoodsMap/goods/grossMargin/export',
    categoryGrossMarginExport: '/api/eros/so/soBillOrderGoodsMap/category/grossMargin/export',
    brandGrossMarginExport: '/api/eros/so/soBillOrderGoodsMap/brand/grossMargin/export',
    dayGrossMarginExport: '/api/eros/so/soBillOrderGoodsMap/day/grossMargin/export',
    storeGrossMarginExport: '/api/eros/so/soBillOrderGoodsMap/store/grossMargin/export',
    situationExport: '/api/eros/so/soBillOrder/situation/export',
    goodsSalesSummaryExport: '/api/eros/so/soBillOrder/goods/salesSummary/export',
    categorySalesSummaryExport: '/api/eros/so/soBillOrder/category/salesSummary/export',
    brandSalesSummaryExport: '/api/eros/so/soBillOrder/brand/salesSummary/export',
    supplierSalesSummaryExport: '/api/eros/so/soBillOrder/supplier/salesSummary/export',
    daySalesSummaryExport: '/api/eros/so/soBillOrder/day/salesSummary/export',
    monthSalesSummaryExport: '/api/eros/so/soBillOrder/month/salesSummary/export',
    storeSalesSummaryExport: '/api/eros/so/soBillOrder/store/salesSummary/export',
    storeDaySalesSummaryExport: '/api/eros/so/soBillOrder/store/day/salesSummary/export',
    payDetail: '/api/eros/so/soBillOrderPay/list',
    csCommissionScheme: '/api/eros/cs/csCommissionScheme', // 提成方案
    payReport: '/api/eros/so/soBillOrderPay/pay/report',
    customerAnalysisExport: '/api/eros/so/soBillOrder/customer/hour/analysis/export'

  },
  weigh: {
    cleanOrder: '/api/eros/wg/wgCleanOrder',
    taste: '/api/eros/wg/wgTaste'
  },
  report: {
    reportStatical: '/api/eros/we/weWarehouseGoodsMap/store/inventory',
    staticalEcharts: '/api/eros/we/weWarehouseGoodsMap/store/inventory/graph',
    merchantStatical: '/api/eros/we/weWarehouseGoodsMap/supplier/inventory',
    merchantEcharts: '/api/eros/we/weWarehouseGoodsMap/supplier/inventory/graph',
    categoryStatical: '/api/eros/we/weWarehouseGoodsMap/category/inventory',
    categorysEcharts: '/api/eros/we/weWarehouseGoodsMap/category/inventory/graph',
    Summary: '/api/eros/mb/mbConsumptionRecord/store/consume',
    SummaryEcharts: '/api/eros/mb/mbConsumptionRecord/store/consume/list',
    meAnalyseEcharts: '/api/eros/so/soBillOrder/member/analysis/store/echarts', // 会员构成分析 --按开卡门店
    meAnalyseExport: '/api/eros/so/soBillOrder/member/analysis/store/export',
    meCategoryEcharts: '/api/eros/so/soBillOrder/member/analysis/category/echarts', // 会员构成分析 --按会员类别
    meCategoryExport: '/api/eros/so/soBillOrder/member/analysis/category/export',
    getGoodsDetail: '/api/eros/as/asGoods/goods/stat',
    lossEacharts: '/api/eros/we/weAdjustInventoryOrder/goods/breakage/echarts',
    trendEcharts: '/api/eros/so/soBillOrder/sales/analysis/echarts',
    trendList: '/api/eros/so/soBillOrder/sales/analysis/list',
    totalEcharts: '/api/eros/so/soBillOrder/sales/sum/echarts',
    totalList: '/api/eros/so/soBillOrder/sales/sum/list',
    trendExport: '/api/eros/so/soBillOrder/sales/analysis/export',
    totalExport: '/api/eros/so/soBillOrder/sales/sum/export',
    storeAnalyseEcharts: '/api/eros/so/soBillOrder/business/store/list', // 营业占比分析-按门店
    storeAnalyseExport: '/api/eros/so/soBillOrder/business/store/export',
    categoryAnalyseEcharts: '/api/eros/so/soBillOrder/business/category/list', // 营业占比分析-按商品分类
    categoryAnalyseExport: '/api/eros/so/soBillOrder/business/category/export',
    brandAnalyseEcharts: '/api/eros/so/soBillOrder/business/brand/list', // 营业占比分析-按品牌
    brandAnalyseExport: '/api/eros/so/soBillOrder/business/brand/export',
    merchantAnalyseEcharts: '/api/eros/so/soBillOrder/business/supplier/list', // 营业占比分析-按供应商
    merchantAnalyseExport: '/api/eros/so/soBillOrder/business/supplier/export',
    cashierAnalyseEcharts: '/api/eros/so/soBillOrder/business/user/list', // 营业占比分析-按导购员/收银员
    cashierAnalyseExport: '/api/eros/so/soBillOrder/business/user/export',
    paymentAnalyseEcharts: '/api/eros/so/soBillOrder/business/pay/list', // 营业占比分析-按支付方式
    paymentAnalyseExport: '/api/eros/so/soBillOrder/business/pay/export',
    memberAnalyseEcharts: '/api/eros/so/soBillOrder/business/member/list', // 营业占比分析-按是否是会员
    memberAnalyseExport: '/api/eros/so/soBillOrder/business/member/export',
    goodsSales: '/api/eros/so/soBillOrder/goods/sales',
    goodsTrendEcharts: '/api/eros/so/soBillOrder/goods/sales/echarts', // 商品销售统计
    goodsUnmarketable: '/api/eros/so/soBillOrder/goods/unmarketable', // 商品滞销
    goodsSalesRecord: '/api/eros/so/soBillOrder/goods/sales/member',
    goodsExport: '/api/eros/so/soBillOrder/goods/sales/export',
    goodsSalesExport: '/api/eros/so/soBillOrder/goods/sales/member/export', // 商品销售统计会员销售弹框导出
    warehouseWaring: '/api/eros/as/asGoods/inventory/warning', // 库存预警
    memberAddEcharts: '/api/eros/so/soBillOrder/member/increase/echarts', // 会员增长统计
    memberAddList: '/api/eros/so/soBillOrder/member/increase/list',
    memberAddExport: '/api/eros/so/soBillOrder/member/increase/export',
    depositStatics: '/api/eros/so/soBillOrder/member/save/money', // 会员储值统计
    depositExport: '/api/eros/so/soBillOrder/member/save/money/export',
    memberDetail: '/api/eros/mb/mbDepositRecord', // 会员充值明细
    memberDetailExport: '/api/eros/mb/mbDepositRecord/export', // 会员充值明细导出
    detailExport: '/api/eros/mb/mbDepositRecord/member/recharge/export',
    meSummaryEcharts: '/api/eros/so/soBillOrder/member/consume/summary/echarts', // 会员消费汇总
    meSummaryList: '/api/eros/so/soBillOrder/member/consume/summary/list',
    meSummaryExport: '/api/eros/so/soBillOrder/member/consume/summary/expor',
    guestEcharts: '/api/eros/so/soBillOrder/guest/section/echarts', // 客单价分析
    guestCategoryEcharts: '/api/eros/so/soBillOrder/guest/member/category/echarts',
    guestCategoryList: '/api/eros/so/soBillOrder/guest/member/category/list',
    // saveCardEcharts:"/api/eros/mb/mbDepositRecord/member/recharge/analysis/echarts",  //储值卡分析
    // saveCardList:"/api/eros/mb/mbDepositRecord/member/recharge/analysis/list",
    // saveCardExport:'/api/eros/mb/mbDepositRecord/member/recharge/analysis/export',
    memberForword: '/api/eros/mb/mbMember/member/statistics', // 会员概览
    memberRankCasher: '/api/eros/mb/mbDepositRecord/consume/money/ranking', // 会员排名按消费金额
    memberRecharge: '/api/eros/mb/mbDepositRecord/recharge/money/ranking', // 会员排名按充值
    customePrice: '/api/eros/so/soBillOrder/member/unit/price/statistics',
    memberBuyNum: '/api/eros/so/soBillOrder/member/consume/times/echarts', // 会员消费次数
    memberintensify: '/api/eros/so/soBillOrder/member/consume/density/echarts', // 会员消费密度
    memberStore: '/api/eros/mb/mbMember/store/member/statistics', // 门店会员
    memberDetailEcharts: '/api/eros/mb/mbMember/member/survey', // 会员概况
    intenvoryChange: '/api/eros/so/soBillOrder/inventory/change', // 商品预览--库存变动
    saleFellTable: '/api/eros/so/soBillOrder/goods/vigilant/fall', // 库存预警--商品下跌
    unsaleTable: '/api/eros/so/soBillOrder/goods/vigilant/unsalable', // 滞销商品
    generalGoods: '/api/eros/so/soBillOrder/general/goods/sales/ranking', // 普通商品销售排名
    mcategoryGoods: '/api/eros/so/soBillOrder/goods/category/sales/ranking', // 商品分类销售排名
    storeExportData: '/api/eros/we/weWarehouseGoodsMap/store/inventory/export', // 库存统计--按门店
    categoryExportData: '/api/eros/we/weWarehouseGoodsMap/category/inventory/export', // 库存统计 --按分类
    merchantExportData: '/api/eros/we/weWarehouseGoodsMap/supplier/inventory/export', // 库存统计--按供应商
    commissionDetail: '/api/eros/so/soBillOrder/guide/commission/detail', // 导购员提成明细
    commissionSummary: '/api/eros/so/soBillOrder/guide/commission/summary',// 导购员提成汇总
    commissionDetailExport: '/api/eros/so/soBillOrder/guide/commission/detail/export', // 导购员提成明细
    commissionSummaryExport: '/api/eros/so/soBillOrder/guide/commission/summary/export',// 导购员提成汇总
  },
  mall: {
    mallImg: '/api/eros/mall/mallStoreShuffling',
    navigationCategory: '/api/eros/mall/mallNavigationCategory',
    RecommendGoods: '/api/eros/mall/mallGoodsRecommend',
    newGoods: '/api/eros/mall/mallGoodsNow',
    saleGoods: '/api/eros/mall/mallGoodsSales',
    expressSetting: '/api/eros/mall/mallCourierPrice',
    mallLiveRole: '/api/eros/mall/mallLiveRole', // 直播成员管理
    asGoodsMall: '/api/eros/as/asGoods/mall/sync', // 选择 商城商品列表
    mallLiveGoods: '/api/eros/mall/mallLiveGoods', // 直播间商品 新增
    mallLiveGoodsList: '/api/eros/mall/mallLiveGoods/goods', /// /直播间商品 列表
    mallLiveGoodsImport: '/api/eros/mall/mallLiveGoods/import', // 直播导入商品
    replay: '/api/eros/mall/mallLiveRoom/get/replay ', // 直播回放地址
    pushUrl: '/api/eros/mall/mallLiveRoom/push/url', // 推流地址
    sharedCode: '/api/eros/mall/mallLiveRoom/shared/code', // 直播间二维码
    resetAudit: '/api/eros/mall/mallLiveGoods/reset/audit', // 撤回审核
    mallLiveGoodsDetail: '/api/eros/mall/mallLiveGoods/goods', // 详情 获取审核 id
    liveGoodsAudit: '/api/eros/mall/mallLiveGoods/audit', // 重新提交审核
    auditStatus: '/api/eros/mall/mallLiveGoods/audit/status', // 查询审核商品状态
    mallLiveRoom: '/api/eros/mall/mallLiveRoom'// 新增直播间
  },
  distribution: {
    ddDistributionRecord: '/api/eros/de/deDaOrder',
    uuDistributionRecord: '/api/eros/de/deUuOrder'
  },
  promotion: {
    plan: '/api/eros/mk/mkActivity', // 促销特价添加与查询，查询全局拼了page
    goods: '/api/eros/as/asGoods/activity', // 查询参与活动的商品信息，拼接page
    termination: '/api/eros/mk/mkActivity/termination ',
    activityStatistics: '/api/eros/mk/mkActivity/activity/statistics', // 活动统计
    activityDetail: '/api/eros/mk/mkActivity/activity/detail',// 活动统计详情
    activityDetailExport: '/api/eros/mk/mkActivity/activity/detail/export',// 活动统计详情导出
  },
  settle: {
    supplierBill: '/api/eros/st/stSupplierBillOrder',
    supplierSettlement: '/api/eros/st/stSupplierSettlementOrder',
    jointBill: '/api/eros/st/stJointBillOrder',
    jointSettlement: '/api/eros/st/stJointSettlementOrder',
    supplierPurchaseOrder: '/api/eros/st/stSupplierBillOrder/supplier/purchase/order', // 根据供应商获取采购单
    supplierBillOrder: '/api/eros/st/stSupplierSettlementOrder/supplier/bill/order', // 根据供应商获取对账单信息
    purchaseOrder: '/api/eros/st/stSupplierSettlementOrder/supplier/purchase/order', // 根据供应商获取对账单信息
    jointBillOrder: '/api/eros/st/stJointBillOrder/joint/supplier/order', // 联营供应商获取相应的商品订单
    jointSettlementOrder: '/api/eros/st/stJointSettlementOrder/joint/settlement/order', // 供应商获取未完成结算的联营对账单
    saleData: '/api/eros/st/stSupplierSettlementOrder/sale/data',
    billCustomer: '/api/eros/st/stCustomerBillOrder', // 客户对账单
    wholesaleOrder: '/api/eros/st/stCustomerBillOrder/customer/order',
    settlementCustomer: '/api/eros/st/stCustomerSettlementOrder', // 客户结算单
    billCustomerOrder: '/api/eros/st/stCustomerSettlementOrder/customer/bill/order', // 客户对账单
    customerOrder: '/api/eros/st/stCustomerSettlementOrder/customer/wholesale/order', // 客户获取批发单据
    billFranchise: '/api/eros/st/stFranchiseStoreBillOrder', // 加盟店对账单
    franchiseSettlement: '/api/eros/st/stFranchiseStoreSettlementOrder', // 加盟店结算单
    allocationOrder: '/api/eros/st/stFranchiseStoreBillOrder/franchise/order',// 获取加盟店调拨单
    settlementSetting: '/api/eros/st/stSettlementDefault',// 结算业务设置
    supplierSettlementQuery: '/api/eros/st/stSupplierSettlementMap/supplier/settlement/query',
    supplierSettlementComplete: '/api/eros/st/stSupplierSettlementMap/supplier/settlement/complete',
    customerSettlementQuery: '/api/eros/st/stCustomerSettlementMap/customer/settlement/query',
    customerSettlementComplete: '/api/eros/st/stCustomerSettlementMap/customer/settlement/complete',
    allSettlementExport: '/api/eros/st/stSupplierSettlementMap/supplier/settlement/export',//历史往来账款导出
    supplierUnpaidAccountExport: '/api/eros/st/stSupplierSettlementMap/unpaid/account/export',//未付账款明细导出
    supplierPayAccountExport: '/api/eros/st/stSupplierSettlementMap/pay/account/export',//已付账款明细导出
    customerSettlementExport: '/api/eros/st/stCustomerSettlementMap/customer/settlement/export',//历史往来账款导出
    customerUnpaidAccountExport: '/api/eros/st/stCustomerSettlementMap/unpaid/account/export',//未付账款明细导出
    customerPayAccountExport: '/api/eros/st/stCustomerSettlementMap/pay/account/export',//已付账款明细导出
    supplierOrderDetailExport: '/api/eros/st/stSupplierBillOrder/export/details',
    supplierSettlementDetailExport: '/api/eros/st/stSupplierSettlementOrder/export/details',
    jointBillDetailExport: '/api/eros/st/stJointBillOrder/export/details',
    jointSettlementDetailExport: '/api/eros/st/stJointSettlementOrder/export/details',
    customerBillDetailExport: '/api/eros/st/stCustomerBillOrder/export/details',
    customerSettlementDetailExport: '/api/eros/st/stCustomerSettlementOrder/export/details',
    franchiseStoreBillDetailExport: '/api/eros/st/stFranchiseStoreBillOrder/export/details',
    franchiseStoreSettlementDetailExport: '/api/eros/st/stFranchiseStoreSettlementOrder/export/details',
    customerBillMap: '/api/eros/st/stCustomerBillMap',
    customerSettlementMap: '/api/eros/st/stCustomerSettlementMap',
    franchiseStoreBillMap: '/api/eros/st/stFranchiseStoreBillMap',
    franchiseStoreSettlementMap: '/api/eros/st/stFranchiseStoreSettlementMap',
    jointBillMap: '/api/eros/st/stJointBillMap',
    jointSettlementMap: '/api/eros/st/stJointSettlementMap',
    supplierBillMap: '/api/eros/st/stSupplierBillMap',
    SupplierSettlementMap: '/api/eros/st/stSupplierSettlementMap',
  },
  takeout: {
    takeoutStore: '/api/eros/cd/cdStore', // 门店映射
    cdAreaList: '/api/eros/cd/cdArea/parent/list', // 省市区数据
    cdStoreSync: '/api/eros/cd/cdStore/sync', // 同步门店
    cdStatus: '/api/eros/cd/cdStore/sync/status', // 修改营业状态

    asGoodsSync: '/api/eros/as/asGoods/candao/sync', // 商品管理 新增 查询分页
    cdGoods: '/api/eros/cd/cdGoods', // 批量同步
    cdGoodsStatus: '/api/eros/cd/cdGoods/update/status', // 是否售罄/是否上架
    cdOrder: '/api/eros/cd/cdOrder', // 订单查询
    cdOrderGoods: '/api/eros/cd/cdOrderGoods'// 订单商品信息

  },
  //应用通知
  notify: {
    rule: '/api/eros/nt/ntNotifyRule',//通知规则
    smsRule: '/api/eros/nt/ntNotifySmsRechargeRecord/rule',//短信规则
    rechargeRecord: '/api/eros/nt/ntNotifySmsRechargeRecord',//充值记录
    smsConsumeRecord: '/api/eros/nt/ntSmsConsumeRecode',//短信消费明细
    smsNum: '/api/eros/nt/ntUserSms/quantity',//获取短信数量
    qrCode: '/api/eros/nt/ntNotifySmsRechargeRecord/qr/code'
  }
}



// WEBPACK FOOTER //
// ./src/config/api.js